// @ts-nocheck

import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import { T } from '@/v2/helpers/i18n';
import { TicketDescription } from '@ticketmaster/global-design-system';

type Props = {} & T;

const NoBarcode = ({ t }: Props) => {
  return (
    <TicketDescription>
      <TicketDescription.Header icon="info">
        <TicketDescription.Title>{t('WALLET.TICKETS.LINK_TICKETS')}</TicketDescription.Title>
        <TicketDescription.Description>{t('WALLET.TICKETS.PLEASE_CLAIM_TICKETS')}</TicketDescription.Description>
      </TicketDescription.Header>
    </TicketDescription>
  );
};

export default withTranslation('translation')(memo(NoBarcode));
